/**
 * 조직 구성원 판정 술어 (admin 정본).
 *
 * 구성원 여부는 서버가 배정 축에서 판정해 싣는 `countsAsMember`(company-rbac P7-b-1/2 — `CompanyRole.countsAsMember` 역할을
 * 하나라도 가진 활성 멤버십)다. false는 **외부 연락처**(현장 담당자 `site-staff`만·외부 결재자 배정 0)라는 뜻이고 **조직 권한이 없다**.
 * 옛 `CompanyMember.role`(null = 외부 연락처)은 P7-b-2에서 컬럼과 함께 지워졌다.
 * 조직 구성원을 세거나 역할을 표시하는 화면은 전부 이 술어를 지나야 한다.
 *
 * 서버(`/admin/users`)는 일부러 거르지 않는다 — 결재선 후보·점검 참가자 선택이 외부 인원을
 * 같은 계열 API로 받기 때문이다. **거르는 위치는 소비 화면**이고, 그래서 이 파일이 있다.
 *
 * ⚠️ 2026-08-22: admin 타입이 `role: string`(non-null)이라고 거짓말하는 바람에 tsc가 침묵했고,
 * `role.toUpperCase()`가 런타임에 터져 `/users` 페이지가 통째로 백지가 됐다. 지금은 boolean 두 개라 그 호출 자체가 없다.
 *
 * web 쪽 대응물: `apps/web/src/lib/members.ts`의 `isOrganizationMember`.
 */
export interface MembershipLike {
  isOwner: boolean;
  countsAsMember: boolean;
  organization: { id: string; name: string; category: string };
}

/**
 * 개인/팀 작업공간(WORKSPACE)과 외부 연락처(countsAsMember=false)를 뺀 **비즈니스 조직 멤버십**.
 */
export function businessMemberships<T extends MembershipLike>(memberships: readonly T[]): T[] {
  return memberships.filter((m) => m.organization.category !== 'WORKSPACE' && m.countsAsMember === true);
}
